export default __webpack_public_path__ + "static/media/details.14ad7102.svg";